import React, { useRef } from "react";
import emailjs from "emailjs-com";

const LeadForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_o919xac",
        "template_4w7153l",
        form.current,
        "cfohW8SIbOB19a4xY"
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
        },
        (error) => {
          alert("Failed to send message.");
          console.error(error.text);
        }
      );
  };
  return (
    <section className="py-20 bg-white text-gray-900" id="leadform">
  <div className="max-w-2xl mx-auto px-6">
    <h2 className="text-4xl font-semibold text-center mb-8">
      Let’s Talk About Your Service Needs
    </h2>
    <form ref={form} onSubmit={sendEmail} className="space-y-5 bg-white p-8 rounded-xl shadow-lg">
      <input
        name="company"
        placeholder="Company Name"
        required
        className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
      />
      <input
        name="name"
        placeholder="Your Name"
        required
        className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
      />
      <input
        name="phone"
        placeholder="Phone"
        className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
      />
      <input
        name="email"
        placeholder="Email"
        required
        type="email"
        className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
      />
      <input
        name="units"
        placeholder="How many homes/units you manage?"
        className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
      />

      <div>
        <label className="block font-medium mb-2">What services are you interested in?</label>
        <div className="grid grid-cols-2 gap-2">
          <label className="flex items-center gap-2">
            <input type="checkbox" name="services" value="Appliance" className="accent-blue-600" />
            Appliance
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" name="services" value="Plumbing" className="accent-blue-600" />
            Plumbing
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" name="services" value="Electrical" className="accent-blue-600" />
            Electrical
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" name="services" value="HVAC" className="accent-blue-600" />
            HVAC
          </label>
        </div>
      </div>

      <button
        type="submit"
        className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
      >
        Submit
      </button>
    </form>
  </div>
</section>

  );
}

export default LeadForm;
